import { action, payload } from "ts-action";
import {
  ACTION_ADD_EMPTY_GIFT_GROUP,
  ACTION_ADD_EMPTY_GIFT_GROUP_ITEM,
  ACTION_SEARCH_LOYALTY_GIFT_MENU_ITEMS,
  getLoyaltyGiftMenuAction,
} from "../../../constants";
import { MultiPosGiftList, TLoyaltyCategory } from "../../../types";

export const getLoyaltyGiftMenu = action(
  getLoyaltyGiftMenuAction.requested,
  payload<string | undefined>()
);

export const getLoyaltyGiftMenuSuccess = action(
  getLoyaltyGiftMenuAction.fulfilled,
  payload<{
    menu: TLoyaltyCategory[];
    excludedGiftItemIds: string[];
    gift_list_by_pos_id?: Record<string, MultiPosGiftList>;
  }>()
);

export const getLoyaltyGiftMenuFailure = action(
  getLoyaltyGiftMenuAction.rejected,
  payload<Error>()
);

export const searchLoyaltyGiftMenuItems = action(
  ACTION_SEARCH_LOYALTY_GIFT_MENU_ITEMS,
  payload<{
    search_term: string;
    gift_list_by_pos_id?: Record<string, MultiPosGiftList>;
  }>()
);
